common.View.create('admin::dashboard.StatisticTrend', {

    onDOMLoad() {
        this.initSpark();
        this.initTrendIcon();
    },

    initSpark() {
        // Get dates.
        let dates = this.getValuesProperty('date');

        // Init Sparkline.
        $('.sparkline', this.element).sparkline(this.getValuesProperty('amount'), {
                type: 'bar',
                height: '40',
                barWidth: '4',
                resize: true,
                barSpacing: '5',
                chartRangeMin: 0,
                barColor: this.element.data('color'),
                tooltipFormatter: function (sparkline, options, fields) {
                    return dates[fields[0].offset] + ': ' + fields[0].value + (this.element.data('percentage') ? '%' : '');
                }.bind(this),
            }
        );
    },

    getValuesProperty(property) {
        return _.map(this.element.data('values'), property);
    },

    initTrendIcon() {
        // Abort due to not enough data?
        let values = this.element.data('values');

        if (values.length <= 1 || values[values.length - 1].amount == values[values.length - 2].amount)
            return;

        // Determine trend.
        let goingUp = values[values.length - 1].amount > values[values.length - 2].amount;

        // Set icon.
        $('.trendIcon', this.element)
            .attr('class', 'font-14 ' + (goingUp ? 'ti-angle-up text-green-400' : 'ti-angle-down text-red-400'));
    }

});
